import {
  emptyCompanyProfile,
  normalizeCompanyProfile,
  type CompanyProfileGateway,
  type TenantCompanyProfile,
} from './companyProfile';

/**
 * Speichert die Grundkonfiguration je Mandant im Browser. Bewusst hinter dem async-Gateway, damit
 * der Umzug in die Tenant-Settings-Tabelle nur ein Austausch der Implementierung ist und keine
 * einzige Aufrufstelle anfassen muss.
 */
const storageKey = (tenantId: string) => `forq.tenant.company.${tenantId}.v1`;

export class LocalCompanyProfileGateway implements CompanyProfileGateway {
  async loadProfile(tenantId: string): Promise<TenantCompanyProfile> {
    try {
      const raw = globalThis.localStorage?.getItem(storageKey(tenantId));
      if (!raw) return emptyCompanyProfile;
      return normalizeCompanyProfile(JSON.parse(raw));
    } catch {
      // Ein kaputter Eintrag darf die Seite nicht mitreißen — dann gilt „nicht konfiguriert",
      // und das ist die sichere Richtung: die Ausgaben sperren sich von selbst.
      return emptyCompanyProfile;
    }
  }

  async saveProfile(tenantId: string, profile: TenantCompanyProfile): Promise<TenantCompanyProfile> {
    const normalized = normalizeCompanyProfile(profile);
    try {
      globalThis.localStorage?.setItem(storageKey(tenantId), JSON.stringify(normalized));
    } catch (error) {
      // Ein Logo kann den Speicher sprengen — das muss der Anwender erfahren, nicht stillschweigend
      // verlieren.
      throw new Error(
        error instanceof Error && /quota/i.test(error.message)
          ? 'Die Konfiguration passt nicht in den Browserspeicher – vermutlich ist das Logo zu groß.'
          : 'Die Konfiguration konnte nicht gespeichert werden.',
      );
    }
    return normalized;
  }
}

export function createLocalCompanyProfileGateway(): CompanyProfileGateway {
  return new LocalCompanyProfileGateway();
}
